import { useMutation, useQuery } from '@tanstack/react-query';
import { useApi } from './useApi';
import { queryClient } from './react-query';

export type TermsStatus = {
  required: boolean;
  accepted: boolean;
};

export const useTermsStatus = (enabled: boolean) => {
  const { makeApiRequest } = useApi();
  return useQuery({
    queryKey: ['terms'],
    queryFn: () => makeApiRequest<TermsStatus>('/terms', 'GET'),
    enabled,
    // Only accepting changes it, and that updates the cache directly.
    staleTime: Infinity,
  });
};

export const useAcceptTerms = () => {
  const { makeApiRequest } = useApi();
  return useMutation({
    mutationFn: () => makeApiRequest('/terms/accept', 'POST'),
    onSuccess: () =>
      queryClient.setQueryData<TermsStatus>(['terms'], (status) =>
        status ? { ...status, accepted: true } : status
      ),
  });
};
